// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;

    text-decoration: none;
    font-size: 15px;
    font-weight: 500;
    font-family: 'CeraProRegular', sans-serif;

    color: var(--cl-dark);
}

/* Mobile UX defaults */
html {
    text-size-adjust: 100%;
    height: 100%;
}

:root {
    /*Цвета*/
    --cl-light: #ecf0fa;
    --cl-shadow: #dadee8;
    --cl-bright: #e40136;
    --cl-dark: #0d263f;
    --cl-link: #4096ff;
    --cl-link-hover: #0958d9;
    --cl-surface: #ffffff;
    --cl-surface-2: #f4f7fb;
    --cl-border: #d8dde6;

    /*Ширина разделов (desktop by default)*/
    --w-sidebar: 15%;
    --w-content: 85%;
    --content-max-width: 1000px;

    /* Spacing scale */
    --sp-1: 6px;
    --sp-2: 10px;
    --sp-3: 14px;
    --sp-4: 18px;

    /* Radius */
    --r-1: 10px;
    --r-2: 14px;

    /* Mobile vh helper (set from index.js) */
    --vh: 1vh;

    /* Safe area */
    --safe-top: env(safe-area-inset-top);
    --safe-right: env(safe-area-inset-right);
    --safe-bottom: env(safe-area-inset-bottom);
    --safe-left: env(safe-area-inset-left);
}

body {
    margin: 0;
    padding: 0;

    text-decoration: none;
    font-size: 15px;
    font-weight: 500;
    font-family: 'CeraProRegular', sans-serif;

    color: var(--cl-dark);
    background: var(--cl-light);

    min-height: calc(var(--vh) * 100);
    overflow-x: hidden;

    /* smoother scrolling on mobile */
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: none;

    padding-left: var(--safe-left);
    padding-right: var(--safe-right);
    padding-top: var(--safe-top);
    padding-bottom: var(--safe-bottom);
}

body[data-theme="dark"] {
    --cl-light: #111827;
    --cl-shadow: #243244;
    --cl-dark: #e6edf7;
    --cl-link: #7fb3ff;
    --cl-link-hover: #b9d5ff;
    --cl-surface: #17202d;
    --cl-surface-2: #202b3a;
    --cl-border: #2d3b50;
}

a, button {
    -webkit-tap-highlight-color: transparent;
}

button, input, textarea, select {
    font: inherit;
}

button span {
    color: inherit;
}

strong {
    font-weight: bold;
}

u {
    text-decoration: underline;
}

s {
    text-decoration: line-through;
}

*:focus-visible {
    outline: 2px solid #91caff !important;
    outline-offset: 2px;
}

#textarea-emoji {
    top: 50px
}

.w-100 {
    width: 100%;
}

.w-50 {
    width: 50%;
}

/*Текст*/
.txt-xxl { font-size: 36px; }
.txt-xl { font-size: 27px; }
.txt-l  { font-size: 20px; }
.txt-m  { font-size: 15px; }
.txt-s  { font-size: 12px; }
.txt-xs { font-size: 10px; }

.txt-bold { font-weight: 700; }
.txt-normal { font-weight: 500; }
.txt-thin { font-weight: 300; }
.txt-underline { text-decoration: underline; }
.txt-cursive { font-style: italic; }

.link { color: var(--cl-link); }
.link:hover { color: var(--cl-link-hover); }

/*Отступы*/
.m-auto { margin-left: auto; margin-right: auto; }
.ml-auto { margin-left: auto; }
.mr-auto { margin-right: auto; }
.mt-auto { margin-top: auto; }
.mb-auto { margin-bottom: auto; }

.p-s { padding: 5px; }
.p-m { padding: 15px; }
.pl-m { padding-left: 15px; }
.pb-m { padding-bottom: 15px; }
.pr-m { padding-right: 15px; }
.pt-m { padding-top: 15px; }
.pt-l { padding-top: 25px; }
.pb-l { padding-bottom: 25px; }
.pl-l { padding-left: 25px; }
.pr-l { padding-right: 25px; }

.m-s { margin: 5px; }
.ml-s { margin-left: 5px; }
.mb-s { margin-bottom: 5px; }
.mr-s { margin-right: 5px; }
.mt-s { margin-top: 5px; }

.m-m { margin: 15px; }
.ml-m { margin-left: 15px; }
.mb-m { margin-bottom: 15px; }
.mr-m { margin-right: 15px; }
.mt-m { margin-top: 15px; }

.mt-l { margin-top: 25px; }
.mb-l { margin-bottom: 25px; }
.ml-l { margin-left: 25px; }
.mr-l { margin-right: 25px; }

/*Flex*/
.flex-col { display: flex; flex-direction: column; }
.flex-row { display: flex; flex-direction: row; }
.flex-align-center { align-items: center; }
.flex-justify-center { justify-content: center; }
.flex-justify-between { justify-content: space-between; }

.custom-scroll::-webkit-scrollbar {
    width: 7px;
    background-color: var(--cl-shadow);
}
.custom-scroll::-webkit-scrollbar-thumb {
    background-color: grey;
}

/* Better touch targets on mobile */
button, [role="button"], input, select, textarea {
    touch-action: manipulation;
}

/* Responsive variables & typography */
@media (max-width: 1024px) {
    :root {
        --content-max-width: 100%;
        --w-sidebar: 22%;
        --w-content: 78%;
    }
}

@media (max-width: 768px) {
    :root {
        /* На мобильном обычно лучше сайдбар делать оверлеем (в вашем Sidebar),
           поэтому глобально расширяем контент на 100% */
        --w-sidebar: 0%;
        --w-content: 100%;
        --content-max-width: 100%;
    }

    * {
        font-size: 14px;
    }

    .txt-xxl { font-size: 28px; }
    .txt-xl  { font-size: 22px; }
    .txt-l   { font-size: 18px; }
    .txt-m   { font-size: 14px; }

    .p-m { padding: 12px; }
    .pl-m { padding-left: 12px; }
    .pr-m { padding-right: 12px; }
    .pt-m { padding-top: 12px; }
    .pb-m { padding-bottom: 12px; }

    .m-m { margin: 12px; }
    .ml-m { margin-left: 12px; }
    .mr-m { margin-right: 12px; }
    .mt-m { margin-top: 12px; }
    .mb-m { margin-bottom: 12px; }

    /* make common elements easier to tap */
    button {
        min-height: 44px;
        border-radius: var(--r-2);
    }

    input, select, textarea {
        min-height: 44px;
        border-radius: var(--r-2);
    }
}

@media (max-width: 420px) {
    * {
        font-size: 13px;
    }

    .txt-xxl { font-size: 26px; }
    .txt-xl  { font-size: 20px; }
    .txt-l   { font-size: 17px; }
}
/* Desktop/tablet: content should start after fixed sidebar */
@media (min-width: 769px) {
    #root {
        padding-left: var(--w-sidebar);
    }
}

/* Mobile: no sidebar offset, and reserve space for the topbar (56px) */
@media (max-width: 768px) {
    #root {
        padding-left: 0;
        padding-top: 0px; /* высота .sidebarTopbar */
    }
}
.appModalOverlay {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 14px;
    z-index: 2000;
}

@media (max-width: 768px) {
    .appModalOverlay {
        align-items: flex-end; /* bottom sheet */
        padding: 0;
    }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;;IAEtB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,yCAAyC;;IAEzC,qBAAqB;AACzB;;AAEA,uBAAuB;AACvB;IAEI,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,QAAQ;IACR,mBAAmB;IACnB,oBAAoB;IACpB,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,wBAAwB;IACxB,qBAAqB;IACrB,uBAAuB;IACvB,oBAAoB;;IAEpB,uCAAuC;IACvC,gBAAgB;IAChB,gBAAgB;IAChB,2BAA2B;;IAE3B,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,YAAY;;IAEZ,WAAW;IACX,WAAW;IACX,WAAW;;IAEX,yCAAyC;IACzC,SAAS;;IAET,cAAc;IACd,oCAAoC;IACpC,wCAAwC;IACxC,0CAA0C;IAC1C,sCAAsC;AAC1C;;AAEA;IACI,SAAS;IACT,UAAU;;IAEV,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,yCAAyC;;IAEzC,qBAAqB;IACrB,2BAA2B;;IAE3B,iCAAiC;IACjC,kBAAkB;;IAElB,iCAAiC;IACjC,iCAAiC;IACjC,yBAAyB;;IAEzB,8BAA8B;IAC9B,gCAAgC;IAChC,4BAA4B;IAC5B,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,wBAAwB;IACxB,qBAAqB;IACrB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA,QAAQ;AACR,WAAW,eAAe,EAAE;AAC5B,UAAU,eAAe,EAAE;AAC3B,UAAU,eAAe,EAAE;AAC3B,UAAU,eAAe,EAAE;AAC3B,UAAU,eAAe,EAAE;AAC3B,UAAU,eAAe,EAAE;;AAE3B,YAAY,gBAAgB,EAAE;AAC9B,cAAc,gBAAgB,EAAE;AAChC,YAAY,gBAAgB,EAAE;AAC9B,iBAAiB,0BAA0B,EAAE;AAC7C,eAAe,kBAAkB,EAAE;;AAEnC,QAAQ,qBAAqB,EAAE;AAC/B,cAAc,2BAA2B,EAAE;;AAE3C,UAAU;AACV,UAAU,iBAAiB,EAAE,kBAAkB,EAAE;AACjD,WAAW,iBAAiB,EAAE;AAC9B,WAAW,kBAAkB,EAAE;AAC/B,WAAW,gBAAgB,EAAE;AAC7B,WAAW,mBAAmB,EAAE;;AAEhC,OAAO,YAAY,EAAE;AACrB,OAAO,aAAa,EAAE;AACtB,QAAQ,kBAAkB,EAAE;AAC5B,QAAQ,oBAAoB,EAAE;AAC9B,QAAQ,mBAAmB,EAAE;AAC7B,QAAQ,iBAAiB,EAAE;AAC3B,QAAQ,iBAAiB,EAAE;AAC3B,QAAQ,oBAAoB,EAAE;AAC9B,QAAQ,kBAAkB,EAAE;AAC5B,QAAQ,mBAAmB,EAAE;;AAE7B,OAAO,WAAW,EAAE;AACpB,QAAQ,gBAAgB,EAAE;AAC1B,QAAQ,kBAAkB,EAAE;AAC5B,QAAQ,iBAAiB,EAAE;AAC3B,QAAQ,eAAe,EAAE;;AAEzB,OAAO,YAAY,EAAE;AACrB,QAAQ,iBAAiB,EAAE;AAC3B,QAAQ,mBAAmB,EAAE;AAC7B,QAAQ,kBAAkB,EAAE;AAC5B,QAAQ,gBAAgB,EAAE;;AAE1B,QAAQ,gBAAgB,EAAE;AAC1B,QAAQ,mBAAmB,EAAE;AAC7B,QAAQ,iBAAiB,EAAE;AAC3B,QAAQ,kBAAkB,EAAE;;AAE5B,OAAO;AACP,YAAY,aAAa,EAAE,sBAAsB,EAAE;AACnD,YAAY,aAAa,EAAE,mBAAmB,EAAE;AAChD,qBAAqB,mBAAmB,EAAE;AAC1C,uBAAuB,uBAAuB,EAAE;AAChD,wBAAwB,8BAA8B,EAAE;;AAExD;IACI,UAAU;IACV,kCAAkC;AACtC;AACA;IACI,sBAAsB;AAC1B;;AAEA,mCAAmC;AACnC;IACI,0BAA0B;AAC9B;;AAEA,sCAAsC;AACtC;IACI;QACI,yBAAyB;QACzB,gBAAgB;QAChB,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI;wDACgD;QAChD,eAAe;QACf,iBAAiB;QACjB,yBAAyB;IAC7B;;IAEA;QACI,eAAe;IACnB;;IAEA,WAAW,eAAe,EAAE;IAC5B,WAAW,eAAe,EAAE;IAC5B,WAAW,eAAe,EAAE;IAC5B,WAAW,eAAe,EAAE;;IAE5B,OAAO,aAAa,EAAE;IACtB,QAAQ,kBAAkB,EAAE;IAC5B,QAAQ,mBAAmB,EAAE;IAC7B,QAAQ,iBAAiB,EAAE;IAC3B,QAAQ,oBAAoB,EAAE;;IAE9B,OAAO,YAAY,EAAE;IACrB,QAAQ,iBAAiB,EAAE;IAC3B,QAAQ,kBAAkB,EAAE;IAC5B,QAAQ,gBAAgB,EAAE;IAC1B,QAAQ,mBAAmB,EAAE;;IAE7B,uCAAuC;IACvC;QACI,gBAAgB;QAChB,yBAAyB;IAC7B;;IAEA;QACI,gBAAgB;QAChB,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA,WAAW,eAAe,EAAE;IAC5B,WAAW,eAAe,EAAE;IAC5B,WAAW,eAAe,EAAE;AAChC;AACA,6DAA6D;AAC7D;IACI;QACI,8BAA8B;IAClC;AACJ;;AAEA,uEAAuE;AACvE;IACI;QACI,eAAe;QACf,gBAAgB,EAAE,0BAA0B;IAChD;AACJ;AACA;IACI,eAAe;IACf,QAAQ;IACR,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,aAAa;AACjB;;AAEA;IACI;QACI,qBAAqB,EAAE,iBAAiB;QACxC,UAAU;IACd;AACJ","sourcesContent":["* {\r\n    margin: 0;\r\n    padding: 0;\r\n    box-sizing: border-box;\r\n\r\n    text-decoration: none;\r\n    font-size: 15px;\r\n    font-weight: 500;\r\n    font-family: 'CeraProRegular', sans-serif;\r\n\r\n    color: var(--cl-dark);\r\n}\r\n\r\n/* Mobile UX defaults */\r\nhtml {\r\n    -webkit-text-size-adjust: 100%;\r\n    text-size-adjust: 100%;\r\n    height: 100%;\r\n}\r\n\r\n:root {\r\n    /*Цвета*/\r\n    --cl-light: #ecf0fa;\r\n    --cl-shadow: #dadee8;\r\n    --cl-bright: #e40136;\r\n    --cl-dark: #0d263f;\r\n    --cl-link: #4096ff;\r\n    --cl-link-hover: #0958d9;\r\n    --cl-surface: #ffffff;\r\n    --cl-surface-2: #f4f7fb;\r\n    --cl-border: #d8dde6;\r\n\r\n    /*Ширина разделов (desktop by default)*/\r\n    --w-sidebar: 15%;\r\n    --w-content: 85%;\r\n    --content-max-width: 1000px;\r\n\r\n    /* Spacing scale */\r\n    --sp-1: 6px;\r\n    --sp-2: 10px;\r\n    --sp-3: 14px;\r\n    --sp-4: 18px;\r\n\r\n    /* Radius */\r\n    --r-1: 10px;\r\n    --r-2: 14px;\r\n\r\n    /* Mobile vh helper (set from index.js) */\r\n    --vh: 1vh;\r\n\r\n    /* Safe area */\r\n    --safe-top: env(safe-area-inset-top);\r\n    --safe-right: env(safe-area-inset-right);\r\n    --safe-bottom: env(safe-area-inset-bottom);\r\n    --safe-left: env(safe-area-inset-left);\r\n}\r\n\r\nbody {\r\n    margin: 0;\r\n    padding: 0;\r\n\r\n    text-decoration: none;\r\n    font-size: 15px;\r\n    font-weight: 500;\r\n    font-family: 'CeraProRegular', sans-serif;\r\n\r\n    color: var(--cl-dark);\r\n    background: var(--cl-light);\r\n\r\n    min-height: calc(var(--vh) * 100);\r\n    overflow-x: hidden;\r\n\r\n    /* smoother scrolling on mobile */\r\n    -webkit-overflow-scrolling: touch;\r\n    overscroll-behavior: none;\r\n\r\n    padding-left: var(--safe-left);\r\n    padding-right: var(--safe-right);\r\n    padding-top: var(--safe-top);\r\n    padding-bottom: var(--safe-bottom);\r\n}\r\n\r\nbody[data-theme=\"dark\"] {\r\n    --cl-light: #111827;\r\n    --cl-shadow: #243244;\r\n    --cl-dark: #e6edf7;\r\n    --cl-link: #7fb3ff;\r\n    --cl-link-hover: #b9d5ff;\r\n    --cl-surface: #17202d;\r\n    --cl-surface-2: #202b3a;\r\n    --cl-border: #2d3b50;\r\n}\r\n\r\na, button {\r\n    -webkit-tap-highlight-color: transparent;\r\n}\r\n\r\nbutton, input, textarea, select {\r\n    font: inherit;\r\n}\r\n\r\nbutton span {\r\n    color: inherit;\r\n}\r\n\r\nstrong {\r\n    font-weight: bold;\r\n}\r\n\r\nu {\r\n    text-decoration: underline;\r\n}\r\n\r\ns {\r\n    text-decoration: line-through;\r\n}\r\n\r\n*:focus-visible {\r\n    outline: 2px solid #91caff !important;\r\n    outline-offset: 2px;\r\n}\r\n\r\n#textarea-emoji {\r\n    top: 50px\r\n}\r\n\r\n.w-100 {\r\n    width: 100%;\r\n}\r\n\r\n.w-50 {\r\n    width: 50%;\r\n}\r\n\r\n/*Текст*/\r\n.txt-xxl { font-size: 36px; }\r\n.txt-xl { font-size: 27px; }\r\n.txt-l  { font-size: 20px; }\r\n.txt-m  { font-size: 15px; }\r\n.txt-s  { font-size: 12px; }\r\n.txt-xs { font-size: 10px; }\r\n\r\n.txt-bold { font-weight: 700; }\r\n.txt-normal { font-weight: 500; }\r\n.txt-thin { font-weight: 300; }\r\n.txt-underline { text-decoration: underline; }\r\n.txt-cursive { font-style: italic; }\r\n\r\n.link { color: var(--cl-link); }\r\n.link:hover { color: var(--cl-link-hover); }\r\n\r\n/*Отступы*/\r\n.m-auto { margin-left: auto; margin-right: auto; }\r\n.ml-auto { margin-left: auto; }\r\n.mr-auto { margin-right: auto; }\r\n.mt-auto { margin-top: auto; }\r\n.mb-auto { margin-bottom: auto; }\r\n\r\n.p-s { padding: 5px; }\r\n.p-m { padding: 15px; }\r\n.pl-m { padding-left: 15px; }\r\n.pb-m { padding-bottom: 15px; }\r\n.pr-m { padding-right: 15px; }\r\n.pt-m { padding-top: 15px; }\r\n.pt-l { padding-top: 25px; }\r\n.pb-l { padding-bottom: 25px; }\r\n.pl-l { padding-left: 25px; }\r\n.pr-l { padding-right: 25px; }\r\n\r\n.m-s { margin: 5px; }\r\n.ml-s { margin-left: 5px; }\r\n.mb-s { margin-bottom: 5px; }\r\n.mr-s { margin-right: 5px; }\r\n.mt-s { margin-top: 5px; }\r\n\r\n.m-m { margin: 15px; }\r\n.ml-m { margin-left: 15px; }\r\n.mb-m { margin-bottom: 15px; }\r\n.mr-m { margin-right: 15px; }\r\n.mt-m { margin-top: 15px; }\r\n\r\n.mt-l { margin-top: 25px; }\r\n.mb-l { margin-bottom: 25px; }\r\n.ml-l { margin-left: 25px; }\r\n.mr-l { margin-right: 25px; }\r\n\r\n/*Flex*/\r\n.flex-col { display: flex; flex-direction: column; }\r\n.flex-row { display: flex; flex-direction: row; }\r\n.flex-align-center { align-items: center; }\r\n.flex-justify-center { justify-content: center; }\r\n.flex-justify-between { justify-content: space-between; }\r\n\r\n.custom-scroll::-webkit-scrollbar {\r\n    width: 7px;\r\n    background-color: var(--cl-shadow);\r\n}\r\n.custom-scroll::-webkit-scrollbar-thumb {\r\n    background-color: grey;\r\n}\r\n\r\n/* Better touch targets on mobile */\r\nbutton, [role=\"button\"], input, select, textarea {\r\n    touch-action: manipulation;\r\n}\r\n\r\n/* Responsive variables & typography */\r\n@media (max-width: 1024px) {\r\n    :root {\r\n        --content-max-width: 100%;\r\n        --w-sidebar: 22%;\r\n        --w-content: 78%;\r\n    }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    :root {\r\n        /* На мобильном обычно лучше сайдбар делать оверлеем (в вашем Sidebar),\r\n           поэтому глобально расширяем контент на 100% */\r\n        --w-sidebar: 0%;\r\n        --w-content: 100%;\r\n        --content-max-width: 100%;\r\n    }\r\n\r\n    * {\r\n        font-size: 14px;\r\n    }\r\n\r\n    .txt-xxl { font-size: 28px; }\r\n    .txt-xl  { font-size: 22px; }\r\n    .txt-l   { font-size: 18px; }\r\n    .txt-m   { font-size: 14px; }\r\n\r\n    .p-m { padding: 12px; }\r\n    .pl-m { padding-left: 12px; }\r\n    .pr-m { padding-right: 12px; }\r\n    .pt-m { padding-top: 12px; }\r\n    .pb-m { padding-bottom: 12px; }\r\n\r\n    .m-m { margin: 12px; }\r\n    .ml-m { margin-left: 12px; }\r\n    .mr-m { margin-right: 12px; }\r\n    .mt-m { margin-top: 12px; }\r\n    .mb-m { margin-bottom: 12px; }\r\n\r\n    /* make common elements easier to tap */\r\n    button {\r\n        min-height: 44px;\r\n        border-radius: var(--r-2);\r\n    }\r\n\r\n    input, select, textarea {\r\n        min-height: 44px;\r\n        border-radius: var(--r-2);\r\n    }\r\n}\r\n\r\n@media (max-width: 420px) {\r\n    * {\r\n        font-size: 13px;\r\n    }\r\n\r\n    .txt-xxl { font-size: 26px; }\r\n    .txt-xl  { font-size: 20px; }\r\n    .txt-l   { font-size: 17px; }\r\n}\r\n/* Desktop/tablet: content should start after fixed sidebar */\r\n@media (min-width: 769px) {\r\n    #root {\r\n        padding-left: var(--w-sidebar);\r\n    }\r\n}\r\n\r\n/* Mobile: no sidebar offset, and reserve space for the topbar (56px) */\r\n@media (max-width: 768px) {\r\n    #root {\r\n        padding-left: 0;\r\n        padding-top: 0px; /* высота .sidebarTopbar */\r\n    }\r\n}\r\n.appModalOverlay {\r\n    position: fixed;\r\n    inset: 0;\r\n    background: rgba(0,0,0,0.45);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 14px;\r\n    z-index: 2000;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .appModalOverlay {\r\n        align-items: flex-end; /* bottom sheet */\r\n        padding: 0;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
